<template>
  <div class="header__wrapper">
    <div
      class="text__wrapper"
      :style="{ width: align === 'center' ? '100%' : '95%' }"
    >
      <h2
        v-balancetext
        v-if="header.title"
        :style="{ textAlign: align }"
      >
        {{ header.title }}
      </h2>
      <p
        v-balancetext
        v-if="header.intro"
        class="sans__reg"
        :style="{ textAlign: align }"
      >
        {{ header.intro }}
      </p>
    </div>
    <!-- <side-illustration v-if="header.sideIllustration" /> -->
    <div v-if="header.illustration" class="illustration">
      <div :is="header.illustration" />
    </div>
  </div>
</template>


<script>
export default {
  name: 'simple-title',
  props: {
    header: {
      type: Object,
      required: true,
    },
    align: {
      type: String,
      required: false,
      default () {
        return 'left'
      },
    },
  },
  components: {},
}
</script>

<style scoped lang="sass">
@import '../styleguide/index.sass'
.header__wrapper
  margin-bottom: $space-5
  display: flex
  justify-content: space-between
  align-items: center

// .text__wrapper
//   width: 95%

.illustration
  position: relative
  display: flex
  flex: 1 1 auto
  min-width: 80px
  width: 170px
  max-height: 100px
  overflow: hidden
  transform: translate(0, -20%) scale(1.5)
  svg
    flex: 1 1 auto


</style>



// WEBPACK FOOTER //
// src/components/headers/simple-title.vue